import {
  MIDDLEWARE_AUTH,
  MIDDLEWARE_CAN,
  MIDDLEWARE_GUEST,
} from '@/router/middleware';
import {t} from '@/utils/helpers';

export default [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "routes" */ '@/components/Layouts/Main.vue'),
    children: [
      // ...App.getRoutes(),
      {
        path: '',
        name: 'home',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Dashboard.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: '/',
            },
          ],
        },
      },
      {
        path: '/jobs',
        name: 'jobs',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Jobs/index.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'Jobs',
              to: '/jobs',
            },
          ],
        },
      },
      {
        path: '/quiz',
        name: 'quiz',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Jobs/quiz.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'Quiz',
              to: '/quiz',
            },
          ],
        },
      },
      {
        path: '/quiz/introduction',
        name: 'quiz',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Jobs/introduction.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'Quiz Introduction',
              to: '/quiz/introduction',
            },
          ],
        },
      },
      {
        path: '/aplication',
        name: 'Aplication',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/aplication/index.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'aplication',
              to: '/aplication',
            },
          ],
        },
      },
      {
        path: '/aplication/detail/:id',
        name: 'Aplication Detail',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/aplication/detail.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'aplication',
              to: '/aplication',
            },
            {
              text: 'Aplication Detail',
              to: '/aplication/detail/:id',
            },
          ],
        },
      },
      {
        path: '/jobs/:id/detail',
        name: 'jobs detail',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Jobs/Detail.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH],
          permissions: ['dashboard'],
          breadcrumbs: [
            {
              text: 'Jobs',
              to: '/jobs',
              exact: true,
            },
            {
              text: t('Detail'),
              to: '/jobs/:id/detail',
              disabled: true,
            },
          ],
        },
      },
      {
        path: '/profile',
        name: 'profile.index',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Users/Biodata/Index.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'users',
              disabled: true,
            },
            {
              text: 'profile',
              to: '/profile',
              exact: true,
            },
          ],
        },
      },
      {
        path: '/skill',
        name: 'skill.index',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Skill/Index.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'users',
              disabled: true,
            },
            {
              text: 'Skill',
              to: '/skill',
              exact: true,
            },
          ],
        },
      },
      {
        path: '/profile/selfie',
        name: 'profile.index',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/profile/selfie.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Profile',
              disabled: true,
            },
            {
              text: 'selfie',
              to: '/profile/selfie',
              exact: true,
            },
          ],
        },
      },
      //edication
      {
        path: '/education',
        name: 'education.index',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Education/index.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Education',
              to: '/education',
              exact: true,
            },
          ],
        },
      },
      //job experience
      {
        path: '/job-experience',
        name: 'experience.index',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/JobExperience/index.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Job Experience',
              to: '/job-experience',
              exact: true,
            },
          ],
        },
      },
      {
        path: '/job-experience/edit/:id',
        name: 'experience.edit',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/JobExperience/Form.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Job Experience',
              to: '/job-experience',
              exact: true,
            },
            {
              text: 'Job Experience Edit',
              to: '/job-experience/edit/:id',
              exact: true,
            },
          ],
        },
      },
      {
        path: '/job-experience/create',
        name: 'experience.create',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/JobExperience/Form.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Job Experience',
              to: '/job-experience',
              exact: true,
            },
            {
              text: 'Job Experience create',
              to: '/job-experience/create',
              exact: true,
            },
          ],
        },
      },
      //upload
      {
        path: '/upload',
        name: 'upload.index',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Upload/index.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Upload',
              to: '/upload',
              exact: true,
            },
          ],
        },
      },
      //certificate
      {
        path: '/cartification',
        name: 'cartification.index',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Cartification/index.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Cartification',
              to: '/cartification',
              exact: true,
            },
          ],
        },
      },
      {
        path: '/education/create',
        name: 'education.create',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Education/Form.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Education',
              to: '/education',
              exact: true,
            },
            {
              text: t('create'),
              disabled: true,
            },
          ],
        },
      },
      {
        path: '/education/edit/:id',
        name: 'education.edit',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Education/FormEdit.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Education',
              to: '/education',
              exact: true,
            },
            {
              text: t('create'),
              disabled: true,
            },
          ],
        },
      },
      {
        path: '/account',
        name: 'account',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Account/index.vue'),
        meta: {
          middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
          permissions: ['budget'],
          breadcrumbs: [
            {
              text: 'Account',
              disabled: true,
            },
          ],
        },
      },
      // Others
      {
        path: '403',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Errors/NotFound.vue'
          ),
        props: {
          title: '403 Forbidden',
          description: "You don't have permission to access this page",
          backToHome: false,
        },
      },
      {
        path: 'unauthorized',
        name: 'unauthorized',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Errors/NotFound.vue'
          ),
        props: {
          title: 'Unauthorized',
          description: "Sorry, you don't have permission to access this page",
        },
      },
    ],
  },
  {
    path: '/auth',
    component: () =>
      import(/* webpackChunkName: "routes" */ '@/components/Layouts/Auth.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Auth/Login.vue'),
        meta: {
          middleware: [MIDDLEWARE_GUEST],
        },
      },
      {
        path: 'register',
        name: 'register',
        component: () =>
          import(/* webpackChunkName: "routes" */ '@/views/Auth/Register.vue'),
        meta: {
          middleware: [MIDDLEWARE_GUEST],
        },
      },
      {
        path: 'register/verify/:user_id/:token',
        name: 'register-verify',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/views/Auth/verificationUser.vue'
          ),
        meta: {
          middleware: [MIDDLEWARE_GUEST],
        },
      },
    ],
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: () =>
      import(
        /* webpackChunkName: "routes" */ '@/views/Password/ChangePassword.vue'
      ),
    meta: {
      middleware: [MIDDLEWARE_AUTH, MIDDLEWARE_CAN],
      permissions: ['budget'],
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () =>
      import(
        /* webpackChunkName: "routes" */ '@/views/Password/ResetPassword.vue'
      ),
    meta: {
      middleware: [MIDDLEWARE_GUEST],
    },
  },
  {
    path: 'unauthorized',
    name: 'unauthorized',
    component: () =>
      import(/* webpackChunkName: "routes" */ '@/views/Errors/NotFound.vue'),
    props: {
      title: 'Unauthorized',
      description: "Sorry, you don't have permission to access this page",
    },
  },
  {
    path: '*',
    component: () =>
      import(/* webpackChunkName: "routes" */ '@/views/Errors/NotFound.vue'),
    props: {
      title: '404 Not Found',
      description: 'Looks like the page you are access is not found',
    },
  },
];
